export const events = [
  {
    name: "GDSC-Meet and Greet",
    info: "An introduction to GDSC, team members, opportunities, and more.",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-the-university-of-louisiana-monroe-presents-gdsc-meet-and-greet/",
  },
  {
    name: "GDSC-Getting Started With GIT",
    info: "A basic introduction to git, github, and version control; All about pushing, pulling , cloning and branching.",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-the-university-of-louisiana-monroe-presents-getting-started-with-git/",
  },
  {
    name: "Hawkthon",
    info: "An exciting hackathon event focused on providing innovative tech solutions for local businesses.",
    link: "../Hawkthon",
  },
  {
    name: "TechXPo",
    info: "A tech exhibition event showcasing the latest tech trends, projects, and innovations.",
    link: "../TechXPo",
  }
];
